import React from 'react';
import PropTypes from 'prop-types';
import IconHeroCar from '@spothero/icons/hero-car';
import {Text, Flex, Icon} from '@spothero/ui';

const StallDisplay = ({stallName}) => {
    if (!stallName) {
        return null;
    }

    const showLogo = stallName.length > 4;

    return (
        <Flex marginX={4} alignItems="center" marginTop={4}>
            <Flex
                backgroundColor="primary.default"
                minWidth={12}
                minHeight={12}
                borderRadius="30px"
                marginRight={3}
                alignItems="center"
                justifyContent="center"
            >
                {showLogo ? (
                    <Icon
                        data-testid="spothero-icon"
                        width={6}
                        height="auto"
                        as={IconHeroCar}
                        color="white"
                    />
                ) : (
                    <Text
                        fontWeight="semibold"
                        fontSize={stallName.length > 2 ? 'base' : 'xl'}
                        color="white"
                    >
                        {stallName}
                    </Text>
                )}
            </Flex>
            <Text data-testid="StallDisplay-text-stall">
                Park at your assigned spot, {stallName}
            </Text>
        </Flex>
    );
};

StallDisplay.propTypes = {
    stallName: PropTypes.string,
};

export default StallDisplay;
